import { useSelector, shallowEqual } from 'react-redux';

import { selectDetails } from 'state/account/account-slice';
import { selectMarketingPreferences } from 'state/user-preferences/user-preferences-slice';
import { anyTrue } from 'utils/misc';
import { PHONE_TYPES, EMAIL_TYPES } from 'config/app-config';

export const useApplicant = () => {
  const account = useSelector(selectDetails, shallowEqual);
  const marketingChannelPreference = useSelector(
    selectMarketingPreferences,
    shallowEqual
  );
  const isMobile = account.phoneType === PHONE_TYPES.MOBILE_PERSONAL;
  const isLandline = !isMobile;

  return {
    title: account.title,
    firstName: account.firstName,
    lastName: account.lastName,
    dateOfBirth: account.birthDate,
    preferredCommunicationMethod: account.preferredCommunicationMethod,
    marketingConsent: anyTrue(marketingChannelPreference)
      ? 'Opt In'
      : 'Opt Out',
    marketingChannelPreference: {
      email: marketingChannelPreference.email,
      mobile: marketingChannelPreference.telephone && isMobile,
      landline: marketingChannelPreference.telephone && isLandline,
      letter: marketingChannelPreference.post,
      'SMS/MMS': marketingChannelPreference.text
    },
    telephoneNumbers: [
      {
        telephoneNumber: account.phoneNumber,
        telephoneNumberType: account.phoneType
      }
    ],
    ...(account.email && {
      emailAddresses: [
        {
          emailAddress: account.email,
          emailAddressType: EMAIL_TYPES.PERSONAL
        }
      ]
    }),
    isChangeOfTenancy: !!account.isChangeOfTenancy
  };
};
